import React, { memo } from "react";
import { Handle, Position, NodeProps } from "@xyflow/react";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as RunJSIcon } from "../../Assets/runjs.svg";
import { ReactComponent as CookiesIcon } from "../../Assets/cookies.svg";
import { ReactComponent as ShowTemplatesIcon } from "../../Assets/showtemplate.svg";
import { ReactComponent as SegmentIcon } from "../../Assets/segment.svg";
import { ReactComponent as EditedIcon } from "../../Assets/EditIcon.svg";
import { ReactComponent as PageIcon } from "../../Assets/page-icon.svg";
interface CustomNodeProps extends NodeProps {
  data: {
    label?: string;
    url?: string;
    cookiedetails?: string;
    color: string;
    title: string;
    matchType: string;
    delayType: string;
    id: string;
    segmentId: string;
    includedUrls: string;
    meterName: string;
    meterTitle: string;
    equalUnit: string;
    type:
      | "page"
      | "segment"
      | "cookie"
      | "runjs"
      | "showTemplate"
      | "viewExit"
      | "pageMeter"
      | "meterValue"
      | "interaction";
    name: string;
    audienceType: string;
    displayType: string;
    cookietitle: string;
    desktopSide: string;
    intTitle: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  };
}

const getNodeIcon = (type: string) => {
  switch (type) {
    case "page":
      return <PageIcon fontSize="small" />;
    case "segment":
      return <SegmentIcon fontSize="small" />;
    case "cookie":
      return <CookiesIcon fontSize="small" />;
    case "runjs":
      return <RunJSIcon fontSize="small" />;
    case "showTemplate":
      return <ShowTemplatesIcon fontSize="small" />;
    case "ViewExit":
      return <ShowTemplatesIcon fontSize="small" />;
    default:
      return null;
  }
};

const ColorSelectorNode: React.FC<CustomNodeProps> = ({
  data,
  isConnectable,
}) => {
  const navigate = useNavigate();
  const handleEdit = (data: any) => {
    switch (data.type) {
      case "page":
        const pageId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-page/${pageId ?? ""}`, { state: { data } });
        break;
      case "segment":
        const segmentId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-user-segment/${segmentId ?? ""}`, { state: { data } });
        break;
        case "interaction":
        const intId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-interaction/${intId ?? ""}`, { state: { data } });
        break;
      case "cookie":
        const cookieId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-set-cookie/${cookieId ?? ""}`, { state: { data } });
        break;
      case "runjs":
        const runJsId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-run-js/${runJsId ?? ""}`, { state: { data } });
        break;
      case "showTemplate":
        const templateId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-show-template/${templateId ?? ""}`, {
          state: { data },
        });
        break;
      case "viewExit":
        const viewExitId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-view-port/${viewExitId ?? ""}`, { state: { data } });
        break;
      case "pageMeter":
        const pageMeterId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-page-meter/${pageMeterId ?? ""}`, { state: { data } });
        break;
      case "meterValue":
        const meterValueId = data.id?.match(/\d+$/)?.[0];
        navigate(`/edit-page-value/${meterValueId ?? ""}`, { state: { data } });
        break;
      default:
        console.warn("Unknown type:", data.type);
    }
  };

  return (
    <div className="rotateNode" data-segment-id={data.segmentId}>
      <div className="rotateNode__header">
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {getNodeIcon(data.type)}
          <p>
            {data.label ||
              data.type.charAt(0).toUpperCase() + data.type.slice(1)}
          </p>
        </div>
        <div>
          <IconButton
            sx={{
              background: "rgb(247, 247, 247)",
              borderRadius: "0px",
              border: " 0.5px solid rgba(223, 223, 223, 1)",
            }}
            size="small"
            onClick={() => handleEdit(data)}
          >
            <EditedIcon className="fs_14" fontSize="small" />
          </IconButton>
        </div>
      </div>

      {data.type === "page" && data.title && (
        <div className="rotateNode__body">
          <div className="rotateNode__body--heading">
            <p>Title:</p>{" "}
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",  whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis'}}>
              {data.title}
            </p>
          </div>
          <div className="rotateNode__body--heading">
            <p>Match Type:</p>{" "}
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)" ,whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis'}}>
              {data.matchType}
            </p>
          </div>
        </div>
      )}
      {data.type === "segment" && data.name && (
        <div className="rotateNode__body">
          <div className="rotateNode__body--heading">
            <p> Title:</p>
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {" "}
              {data.name}
            </p>
          </div>
          <div className="rotateNode__body--heading">
            <p> Audience Type:</p>
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.audienceType}
            </p>
          </div>
        </div>
      )}
      {data.type === "interaction" && data.intTitle && (
        <div className="rotateNode__body">
          <div >
            <p>Title:</p>
            <ul>
              <li
                style={{
                  fontWeight: "500",
                  color: "rgba(0, 0, 0, 1) ",
                  margin: "5px 0px",
                }}
              >
                {" "}
                {data.intTitle}
              </li>
            </ul>
          </div>
        </div>
      )}
      {data.type === "cookie" && data.cookiedetails && (
        <div className="rotateNode__body">
          <div className="rotateNode__body--heading">
            <p>Title:</p>

            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.title}
            </p>
          </div>
          <div className="rotateNode__body--heading">
            <p>Name:</p>
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.cookiedetails}
            </p>
          </div>
        </div>
      )}
      {data.type === "runjs" && data.title && (
        <div className="rotateNode__body">
          <div >
            <p>Title:</p>
            <ul>
              <li
                style={{
                  fontWeight: "500",
                  color: "rgba(0, 0, 0, 1) ",
                  margin: "5px 0px",
                }}
              >
                {" "}
                {data.title}
              </li>
            </ul>
          </div>
        </div>
      )}
      {data.type === "viewExit" && data.title && (
        <div className="rotateNode__body">
          <div className="rotateNode__body--heading">
            <p>Title:</p>
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.title}
            </p>
          </div>
          <div className="rotateNode__body--heading">
            <p>Desktop Side:</p>
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.desktopSide}
            </p>
          </div>
        </div>
      )}
      {data.type === "showTemplate" && data.delayType && (
        <div className="rotateNode__body">
          <div className="rotateNode__body--heading">
            <p>Type:</p>
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.delayType}
            </p>
          </div>
          <div className="rotateNode__body--heading">
            <p>Display Type:</p>{" "}
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.displayType}
            </p>
          </div>
        </div>
      )}
      {data.type === "pageMeter" && data.meterName && (
        <div className="rotateNode__body">
          <div className="rotateNode__body--heading">
            <p>Title:</p> <p>{data.meterTitle}</p>
          </div>
          <div className="rotateNode__body--heading">
            <p>Meter Name:</p>
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)",whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.meterName}
            </p>
          </div>
        </div>
      )}
      {data.type === "meterValue" && data.title && (
        <div className="rotateNode__body">
          <div className="rotateNode__body--heading">
            <p>Title:</p>{" "}
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)" ,whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.title}
            </p>
          </div>
          <div className="rotateNode__body--heading">
            <p>Equal Unit:</p>{" "}
            <p style={{ fontWeight: "500", color: "rgba(0, 0, 0, 1)" ,whiteSpace:'nowrap' , overflow:'hidden', textOverflow:'ellipsis' }}>
              {data.equalUnit}
            </p>
          </div>
        </div>
      )}

      <Handle
        style={{
          background: "rgb(228, 0, 43)",
        }}
        type="target"
        position={Position.Left}
        isConnectable={isConnectable}
      />
      <Handle
        style={{
          background: "rgb(228, 0, 43)",
        }}
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
      />
    </div>
  );
};

export default memo(ColorSelectorNode);
